import React, { useEffect, useCallback } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import moment from "moment";
import { useHistory } from "react-router-dom"
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Pagination } from "../../../../_metronic/_partials/controls";
import * as vrAction from "../redux/vrAction";


export function VolunteerRequestTable({ UIEvent, searchName }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const vrReducer = useSelector(state => state.vr, shallowEqual);

  const requestDataTableCallback = useCallback((page, per_page) => {
    dispatch(vrAction.vrTableRequest({
      name: searchName,
    }));
  }, [dispatch, searchName])

  useEffect(() => {
    requestDataTableCallback();
  }, [ requestDataTableCallback, searchName ])

  const nullColumnFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <span>
        {cell === null ? 'N/A' : cell}
      </span>
    )
  }

  const activityColumnFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <span role="button">
        {cell === null ? 'N/A' : cell}
      </span>
    )
  }

  const dateColumnFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <span>
        {cell === null ? 'N/A' : moment(cell).format("DD-MM-YYYY")}
      </span>
    )
  }

  const availSessionColumnFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <span>
        {row.RecordType.Name === "Food Packing" ? cell : '-'}
      </span>
    )
  }
  
  const columns = [
    {
      dataField: "Name",
      text: "Activity/Event",
      formatter: activityColumnFormatter
    },
    {
      dataField: "Start_Date__c",
      text: "Start Date",
      formatter: dateColumnFormatter
    },
    {
      dataField: "End_Date__c",
      text: "End Date",
      formatter: dateColumnFormatter
    },
    {
      dataField: "RecordType.Name",
      text: "Record Type",
      formatter: nullColumnFormatter
    },
    {
      dataField: "Available_Session__c",
      text: "Available Session",
      formatter: availSessionColumnFormatter
    },
  ];
  
  const paginationOptions = {
    custom: true,
    totalSize: 12,
    sizePerPageList: [
      { text: "10", value: 10 }
    ],
    sizePerPage: 10,
    page: 1,
  };

  function onTableChange(type, newState){
    console.log(type);
    console.log(newState);
    // let tmpMeta = {...tableContext.table.meta};
    // tmpMeta.page = newState.page;
    // tmpMeta.per_page = newState.sizePerPage;
    // tableContext.handleChangeField('meta', '', tmpMeta);
  }

  const selectRow = {
    mode: 'radio',
    hideSelectColumn: true,
    clickToSelect: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      if(row?.RecordType?.Name === "Regular"){
        history.push({
          pathname: `/volunteer-request/detail/regular/${row.Id}`,
          data: row
        })
      } else if(row?.RecordType?.Name === "Food Packing"){
        history.push({
          pathname: `/volunteer-request/detail/fp/${row.Id}`,
          data: row
        })
      }
    }
  };

  return (
    <>
      {/* <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={vrReducer.isLoading}
              paginationProps={paginationProps}
            > */}
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="Id"
                data={vrReducer.vrTable === null ? [] : vrReducer.vrTable?.data?.volunteerRequests}
                columns={columns}
                hover
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={onTableChange}
                selectRow={selectRow}
                // {...paginationTableProps}
              >
                {/* <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} /> */}
              </BootstrapTable>
              {
                vrReducer.vrTable === null &&
                <div>
                  Please wait...
                </div>  
              }
            {/* </Pagination>
          );
        }}
      </PaginationProvider> */}
    </>
  );
}
